/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './CircledCheckIcon.style';

import svg from './circled-check.svg';

type Props = {
  className?: string,
  title?: string,
  // Self passed
};

const useStyles = createUseThemeStyles(styles);

const CircledCheckIcon = ({ className, title }: Props): React.Node => {
  const classes = useStyles();

  // Classes

  const rootClasses = classNames(classes.root, className);

  return <BaseIcon className={rootClasses} svg={svg} title={title} />;
};

export default React.memo<Props>(CircledCheckIcon);
